import { Box, Radio, RadioGroup, FormControlLabel, FormControl } from '@mui/material';
import React, { FC, useState, ChangeEvent, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { Order } from 'models/order';

type InvoiceStateModuleProps = {
    invoiceState: string;
    onChangeInvoice: (value: string) => void;
    isOrderInvoiced?: boolean;
    order?: Order;
};

const InvoiceStateModule: FC<InvoiceStateModuleProps> = ({
    onChangeInvoice,
    isOrderInvoiced,
    order,
    invoiceState,
}: InvoiceStateModuleProps) => {
    const { t: translate } = useTranslation(['orders']);
    const [invoice, setInvoice] = useState('');

    useEffect(() => {
        setInvoice(invoiceState);
    }, [invoiceState]);

    const handleChange = (event: ChangeEvent<HTMLInputElement>) => {
        setInvoice((event.target as HTMLInputElement).value);
        onChangeInvoice((event.target as HTMLInputElement).value);
    };

    return (
        <Box>
            <FormControl component="fieldset">
                <RadioGroup row onChange={handleChange} value={invoice}>
                    <FormControlLabel
                        value="NOT_READY"
                        disabled={isOrderInvoiced}
                        control={<Radio color="secondary" data-test="invoice-state-module.not-ready-radio" />}
                        label={translate('orders:NOT_READY')}
                    />
                    <FormControlLabel
                        value="READY_FOR_INVOICE"
                        disabled={
                            isOrderInvoiced || !order?.deliveryDetails?.price || order?.deliveryDetails?.price === 0
                        }
                        control={<Radio color="secondary" data-test="invoice-state-module.ready-for-invoice-radio" />}
                        label={translate('orders:READY_FOR_INVOICE')}
                    />
                    <FormControlLabel
                        value="SHOULD_NOT_INVOICE"
                        disabled={isOrderInvoiced}
                        control={<Radio color="secondary" data-test="invoice-state-module.should-not-invoice-radio" />}
                        label={translate('orders:DO_NOT_INVOICE')}
                    />
                </RadioGroup>
            </FormControl>
        </Box>
    );
};

export default InvoiceStateModule;
